import React from 'react'

// import TeachersData from '../components/TeachersData'
import '../css/stafff.css'
import HorizontalTabs from '../components/HorizontalTabs';


function ourstaff() {

  return (
    <div className='teacherstaff-mainbox'>
       <div className='ibdp-hero-sec'>
        <img src='img/IMG_0044.webp'/>
      </div>
 
      <div className='our-staff'>
        {/* <HorizontalTabs tabs={tabs} /> */}

        <div className='teacher-list'>
      <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Manisha-Chandra01.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Ms. Manisha Chandra</h1>
            <h5><span>Designation:</span> Vice Principal /IBDP Coordinator / TOK Coordinator / DP Mathematics Facilitator</h5>
            <h5><span>Qualification:</span> M.Sc. (Mathematics), B.Ed.</h5>
            </div>
            </div>
        </div>
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Deepika.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Ms. Deepika Seth</h1>
            <h5><span>Designation:</span>APYPC</h5>
            <h5><span>Qualification:</span> M.A, B.Ed.</h5>
            </div>
            </div>
        </div>
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Shuchita mathur.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Ms. Shuchita Mathur</h1>
            <h5><span>Designation:</span>APYPC</h5>
            <h5><span>Qualification:</span>M.Sc., N.T.T.</h5>
            </div>
            </div>
        </div>
     
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Rakhshanda hafeez khan (1).webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Ms. Rakhshanda Hafeez Khan</h1>
            <h5><span>Designation:</span>Cambridge Coordinator/ IGCSE English Facilitator / DP English Facilitator</h5>
            <h5><span>Qualification:</span> M.A. (English Lit.), B.Ed.</h5>
            </div>
            </div>
        </div>

        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Charu.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1> Ms. Charu Kapoor</h1>
            <h5><span>Designation:</span> DP Visual Arts Facilitator</h5>
            <h5><span>Qualification:</span>CM.F.A. (FINE ARTS)</h5>
            </div>
            </div>
        </div>
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Mona singh.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Dr. Mona Singh</h1>
            <h5><span>Designation:</span> IBDP Psychology / IGCSE Facilitator</h5>
            <h5><span>Qualification:</span>PhD, M.Sc., B.Ed.</h5>
            </div>
            </div>
        </div>
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Vidhi Sharma.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Ms. Vidhi Sharma</h1>
            <h5><span>Designation:</span>DP DP / CS / IGCSE Facilitator</h5>
            <h5><span>Qualification:</span>M.Sc.(I.T.), MCA</h5>
            </div>
            </div>
        </div>
     
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Saloni.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Ms. Saloni Jain</h1>
            <h5><span>Designation:</span>DP Business Manegement Facilitator</h5>
            <h5><span>Qualification:</span>B.M.I.T, MBA,B.Ed.</h5>
            </div>
            </div>
        </div>
        
        {/* <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/teacher pic/PUSHPENDRA TIWARI.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>	   Mr. Pushpendra Tiwari</h1>
            <h5><span>Designation:</span>DP Biology Facilitator</h5>
            <h5><span>Qualification:</span>M.Sc.(Zoology), B.Ed., Ph.D</h5>
            </div>
            </div>
        </div> */}
       
        {/* <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/No_Image_Available.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1> Ms. Sneh Rathore</h1>
            <h5><span>Designation:</span> DP Chemistry Facilitator</h5>
            <h5><span>Qualification:</span>M.Sc.,(Chemistry), B.Ed.</h5>
            </div>
            </div>
        </div> */}
        
        {/* <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Manish Kedawat.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Mr. Manish Kedawat</h1>
            <h5><span>Designation:</span> DP Physics Facilitator / EE Coordinator/ IGCSE  </h5>
            <h5><span>Qualification:</span> M.Sc. (Physics), B.Ed.</h5>
            </div>
            </div>
        </div> */}
        
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Sangeeta vyas.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1> Ms. Sangeeta Vyas</h1>
            <h5><span>Designation:</span> DP Hindi Facilitator</h5>
            <h5><span>Qualification:</span>M.A., B.Ed.</h5>
            </div>
            </div>
        </div>
        
        {/* <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Namita Choudhary.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1> Ms. Namita Choudhary</h1>
            <h5><span>Designation:</span>DP Economics Facilitator / IGCSE / CAS Coordinator </h5>
            <h5><span>Qualification:</span> M.Com., B.Ed</h5>
            </div>
            </div>
        </div> */}
     
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Arvind kumar sharma.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Mr. Arvind Sharma</h1>
            <h5><span>Designation:</span>  IGCSE Facilitator</h5>
            <h5><span>Qualification:</span>  M.Sc., B.Ed.</h5>
            </div>
            </div>
        </div>
        
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Nitu nirwan.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1> Ms. Nitu Nirwan</h1>
            <h5><span>Designation:</span> IGCSE Facilitator</h5>
            <h5><span>Qualification:</span> M.Sc., B.Ed.</h5>
            </div>
            </div>
        </div>

        
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Shilpa nigam.webp'/>
      
            </div>
            <div className='teacher-data-box'>
            <h1>Ms. Shilpa Nigam</h1>
            <h5><span>Designation:</span>IGCSE Facilitator</h5>
            <h5><span>Qualification:</span> M.Sc.(IT), B.Ed.</h5>
            </div>
            </div>
        </div>

        
        {/* <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/teacher pic/VINOD KUMAR SHARMA.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Mr. Vinod Sharma</h1>
            <h5><span>Designation:</span>CAS Supervisor</h5>
            <h5><span>Qualification:</span>M.P.Ed, NIS in Basketball</h5>
            </div>
            </div>
        </div> */}
        
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Poorva.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Ms. Poorva Sharma</h1>
            <h5><span>Designation:</span> IGCSE Facilitator</h5>
            <h5><span>Qualification:</span>M.A.(Geography), B.Ed.</h5>
            </div>
            </div>
        </div>
        
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Shanu Choudhary.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Ms. Shanu Choudhary</h1>
            <h5><span>Designation:</span>IGCSE Facilitator</h5>
            <h5><span>Qualification:</span>M.A., PGDCA, B.Ed.</h5>
            </div>
            </div>
        </div>
        
        {/* <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/teacher pic/MONIKA RATHORE.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Ms. Monika Rathore</h1>
            <h5><span>Designation:</span>IGCSE Facilitator</h5>
            <h5><span>Qualification:</span>B.A., B.Ed.</h5>
            </div>
            </div>
        </div> */}
        
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Vasundra chauhan.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Ms. Vasundhara Chauhan</h1>
            <h5><span>Designation:</span>PYP Facilitator</h5>
            <h5><span>Qualification:</span>M. Com., B.Ed.</h5>
            </div>
            </div>
        </div>
        
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Shilpa chaudhary.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Ms. Shilpa Choudhary</h1>
            <h5><span>Designation:</span> PYP Facilitator</h5>
            <h5><span>Qualification:</span>B.Sc., M.A., B.Ed.</h5>
            </div>
            </div>
        </div>
        
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Anu-Narula.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Ms. Anu Narula</h1>
            <h5><span>Designation:</span>PYP Facilitator</h5>
            <h5><span>Qualification:</span> M.A., B.Ed.</h5>
            </div>
            </div>
        </div>
        
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Manju soni.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Ms. Manju Soni</h1>
            <h5><span>Designation:</span>PYP Facilitator</h5>
            <h5><span>Qualification:</span>M.A., B.Ed.</h5>
            </div>
            </div>
        </div>
 
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Ritu singh.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1> Ms. Ritu Singh</h1>
            <h5><span>Designation:</span>PYP Facilitator</h5>
            <h5><span>Qualification:</span> B.A., B.Ed.</h5>
            </div>
            </div>
        </div>
 
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Garima rathore.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Ms. Garima Rawat</h1>
            <h5><span>Designation:</span> PYP Facilitator</h5>
            <h5><span>Qualification:</span>B.A., B.Ed.</h5>
            </div>
            </div>
        </div>
 
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Neeru kapoor.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Ms. Neeru Kapoor</h1>
            <h5><span>Designation:</span> PYP Facilitator</h5>
            <h5><span>Qualification:</span>B.Com, B.Ed.</h5>
            </div>
            </div>
        </div>
 
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Ranjan shekhawat.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Ms. Ranjan Shekhawat</h1>
            <h5><span>Designation:</span> PYP Facilitator</h5>
            <h5><span>Qualification:</span>B.Sc., M.A., B.Ed.</h5>
            </div>
            </div>
        </div>

 
        {/* <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'> */}
            {/* <img src='../newimg/Teacher Photo/Ira sharma.webp'/> */}
            {/* <img src='../newimg/Teacher Photo/Supriya yadav.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Ms. Ira Sharma</h1>
            <h5><span>Designation:</span>PYP Facilitator</h5>
            <h5><span>Qualification:</span>B.A., B.Ed.</h5>
            </div>
            </div>
        </div> */}
 
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Dr nidhi pareek.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Ms. Nidhi Pareek</h1>
            <h5><span>Designation:</span>PYP Facilitator</h5>
            <h5><span>Qualification:</span> M.A., M.Ed.</h5>
            </div>
            </div>
        </div>
 
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            {/* <img src='../newimg/Teacher Photo/Ms. Swati Gupta 1.webp'/> */}
            <img src='../newimg/Teacher Photo/Shweta khetan.webp'/>
            
            </div>
            <div className='teacher-data-box'>
            <h1>Ms. Swati Gupta</h1>
            <h5><span>Designation:</span>PYP Facilitator</h5>
            <h5><span>Qualification:</span>M.A., B.Ed.</h5>
            </div>
            </div>
        </div>
 
        {/* <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Tanu joshi.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>  Ms. Tanu Joshi</h1>
            <h5><span>Designation:</span> PYP Facilitator</h5>
            <h5><span>Qualification:</span>B.Sc., B.Ed.</h5>
            </div>
            </div>
        </div> */}
 
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Mani mehra.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Ms. Money Mehra</h1>
            <h5><span>Designation:</span>PYP Facilitator</h5>
            <h5><span>Qualification:</span>M.A., B.Ed.</h5>
            </div>
            </div>
        </div>
 
        
 
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Anchal  midha jain.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>  Ms. Anchal Middha</h1>
            <h5><span>Designation:</span>PYP Facilitator</h5>
            <h5><span>Qualification:</span>M.Com, B.Ed.</h5>
            </div>
            </div>
        </div>
 
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Harshini chauhan.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1> Ms. Harshini Chouhan</h1>
            <h5><span>Designation:</span>PYP Facilitator</h5>
            <h5><span>Qualification:</span>B.Sc., B.Ed.</h5>
            </div>
            </div>
        </div>

 
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Arti Maheshwari.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1> Ms. Arti Maheshwari</h1>
            <h5><span>Designation:</span>PYP Facilitator</h5>
            <h5><span>Qualification:</span>B.Com., B.Ed</h5>
            </div>
            </div>
        </div>
 
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Sunita pawar.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Ms. Sunita Panwar</h1>
            <h5><span>Designation:</span>PYP Facilitator</h5>
            <h5><span>Qualification:</span> B.A., B.Ed.</h5>
            </div>
            </div>
        </div>
 
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Rachna.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Ms. Rachna Lingwal</h1>
            <h5><span>Designation:</span>PYP Facilitator</h5>
            <h5><span>Qualification:</span>M.COM., B.Ed.</h5>
            </div>
            </div>
        </div>
 
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            {/* <img src='../newimg/No_Image_Available.webp'/> */}
            <img src='../newimg/Teacher Photo/Deepa singh.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1> Ms. Deepa Kumari</h1>
            <h5><span>Designation:</span>PYP Facilitator</h5>
            <h5><span>Qualification:</span>M.A., B.Ed.</h5>
            </div>
            </div>
        </div>

 
        {/* <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Karuna sharma.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Ms. Karuna Sharma</h1>
            <h5><span>Designation:</span>PYP Facilitator</h5>
            <h5><span>Qualification:</span> M.A., B.Ed.</h5>
            </div>
            </div>
        </div> */}
 
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Pinky gupta.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1> Ms. Pinki Gupta</h1>
            <h5><span>Designation:</span>PYP Facilitator</h5>
            <h5><span>Qualification:</span>B.Sc., B.Ed.,PGDCA</h5>
            </div>
            </div>
        </div>
 
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Shikha saini.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1> Ms. Shikha Saini</h1>
            <h5><span>Designation:</span>PYP Facilitator</h5>
            <h5><span>Qualification:</span>M.A., NTT, D.El.Ed.</h5>
            </div>
            </div>
        </div>
 
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Vasudha Sharma.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Ms. Vasudha Sharma</h1>
            <h5><span>Designation:</span>PYP Facilitator</h5>
            <h5><span>Qualification:</span>M.A., D.El.Ed.</h5>
            </div>
            </div>
        </div>
 
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Shivangi goswami.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Ms. Shivangi Goswami</h1>
            <h5><span>Designation:</span>PYP Facilitator</h5>
            <h5><span>Qualification:</span> M.Com, BBA, ,D.El.Ed.</h5>
            </div>
            </div>
        </div>
 
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            {/* <img src='../newimg/Teacher Photo/Shweta khetan.webp'/> */}
            <img src='../newimg/Teacher Photo/Sapna sehgal.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Ms. Shweta Khetan</h1>
            <h5><span>Designation:</span>PYP Facilitator</h5>
            <h5><span>Qualification:</span>B.A, D.El.Ed.</h5>
            </div>
            </div>
        </div>
 
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Amrita sengupta.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Ms. Amrita Sengupta</h1>
            <h5><span>Designation:</span>School Counsellor</h5>
            <h5><span>Qualification:</span>B.A., B.Ed., Diploma in Special Education</h5>
            </div>
            </div>
        </div>
 
        

        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Ishan khan.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Mr. Ishan Khan</h1>
            <h5><span>Designation:</span> Music Teacher</h5>
            <h5><span>Qualification:</span>M.A. (English Lit.), B.Ed.</h5>
            </div>
            </div>
        </div>

        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Tripti sharma.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1> Ms. Tripti Sharma</h1>
            <h5><span>Designation:</span> PYP Facilitator</h5>
            <h5><span>Qualification:</span> M.A., B.Ed., L.L.B.</h5>
            </div>
            </div>
        </div>

        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Sunil-Kumawat.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1> Mr. Sunil Kumawat</h1>
            <h5><span>Designation:</span> Dance Teacher</h5>
            <h5><span>Qualification:</span>B.A., Diploma in Dance</h5>
            </div>
            </div>
        </div>
       
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Anjali pareek.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1> Ms. Anjali Pareek</h1>
            <h5><span>Designation:</span>Librarian</h5>
            <h5><span>Qualification:</span> M.Lib.</h5>
            </div>
            </div>
        </div>
       
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Anil kumar gaur.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1> Mr. Anil Kumar Gaur</h1>
            <h5><span>Designation:</span>Sports</h5>
            <h5><span>Qualification:</span>M.Com., B.P.Ed.</h5>
            </div>
            </div>
        </div>
       
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Sanjeev sir.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1> Mr. Sanjeev Soni </h1>
            <h5><span>Designation:</span>Sports</h5>  
            <h5><span>Qualification:</span>B.A.</h5>
            </div>
            </div>
        </div>
      
     
{/*        
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Madina Behlim.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Madina Khan </h1>
            <h5><span>Designation:</span> PYP Facilitator</h5>  
            <h5><span>Qualification:</span> </h5>
            </div>
            </div>
        </div> */}
       
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Uma Rathore.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Uma Rathore </h1>
            <h5><span>Designation:</span> PYP Facilitator</h5>  
            <h5><span>Qualification:</span>M.Com, B.Ed.</h5>
            </div>
            </div>
        </div>
       
      

        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Radhika mishra.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Radhika Mishra </h1>
            <h5><span>Designation:</span> PYP Facilitator</h5>  
            <h5><span>Qualification:</span>B.A., B.Ed.</h5>
            </div>
            </div>
        </div>
      
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            {/* <img src='../newimg/Teacher Photo/Meghna nathawat.webp'/> */}
            <img src='../newimg/Teacher Photo/Ruby gupta.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Meghna Nathawat</h1>
            <h5><span>Designation:</span> PYP Facilitator</h5>  
            <h5><span>Qualification:</span> M.A., B.Ed.</h5>
            </div>
            </div>
        </div>
       
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Meghna nathawat.webp'/>
       
            </div>
            <div className='teacher-data-box'>
            <h1>Ruby Gupta</h1>
            <h5><span>Designation:</span> IGCSE Facilitator</h5>  
            <h5><span>Qualification:</span>M.A., B.Ed. </h5>
            </div>
            </div>
        </div>
     
        {/* <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Poonam jain.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Poonam Jain</h1>
            <h5><span>Designation:</span> PYP Facilitator</h5>  
            <h5><span>Qualification:</span>B. Sc., B.Ed</h5>
            </div>
            </div>
        </div> */}
       
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Kavita rathore.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Kavita Rathore</h1>
            <h5><span>Designation:</span> PYP Facilitator</h5>  
            <h5><span>Qualification:</span>B.A., B.Ed. </h5>
            </div>
            </div>
        </div>
       
        {/* <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Soniya pandey.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Sonia Pandey</h1>
            <h5><span>Designation:</span> PYP Facilitator</h5>  
            <h5><span>Qualification:</span>M.A., B.Ed. </h5>
            </div>
            </div>
        </div> */}
        
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Komal sharma.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Komal Sharma</h1>
            <h5><span>Designation:</span> PYP Facilitator</h5>  
            <h5><span>Qualification:</span>M.A., B.Ed.
            </h5>
            </div>
            </div>
        </div>
        
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            {/* <img src='../newimg/Teacher Photo/Supriya yadav.webp'/> */}
             <img src='../newimg/Teacher Photo/Ira sharma.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Supriya Yadav</h1>
            <h5><span>Designation:</span> PYP Facilitator</h5>  
            <h5><span>Qualification:</span>B.A., B.Ed.</h5>
            </div>
            </div>
        </div>
       
    
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Raju kumar.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Raju Kumar</h1>
            <h5><span>Designation:</span> Drama Teacher </h5>  
            <h5><span>Qualification:</span>B. Com.  </h5>
            </div>
            </div>
        </div>
       
       
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Archan bhoumik.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Mr. Archan Bhoumik</h1>
            <h5><span>Designation:</span> DP Biology / ESS / EVM / CAS Coordinator/ IGCSE Facilitator</h5>  
            <h5><span>Qualification:</span>M.Sc., B.Ed., PGDIE </h5>
            </div>
            </div>
        </div>
       
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Ranjeet singh.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Ranjeet Shigh</h1>
            <h5><span>Designation:</span>IGCSE & IBDP Facilitator</h5>  
            <h5><span>Qualification:</span>M.Sc., B.ED., PGDIE</h5>
            </div>
            </div>
        </div>
      
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Rais khan.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Rais Khan</h1>
            <h5><span>Designation:</span>MUSIC TEACHER</h5>  
            <h5><span>Qualification:</span>B.A. (Music) </h5>
            </div>
            </div>
        </div>
   
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/samuel alfred.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Samuel Alfred</h1>
            <h5><span>Designation:</span>Music Teacher</h5>  
            <h5><span>Qualification:</span>Diploma in Music </h5>
            </div>
            </div>
        </div>
      
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Priyanka Yadav.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Priyanka Yadav</h1>
            <h5><span>Designation:</span>IGCSE Facilitator</h5>  
            <h5><span>Qualification:</span>B.A
            M.A (Public Administration) </h5>
            </div>
            </div>
        </div>
 
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Piyush gupta.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Piyush Gupta</h1>
            <h5><span>Designation:</span>MUSIC TEACHER </h5>  
            <h5><span>Qualification:</span>B. Sc. </h5>
            </div>
            </div>
        </div>
      
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Vishaka soni.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Vishakha Soni</h1>
            <h5><span>Designation:</span> PYP Facilitator </h5>  
            <h5><span>Qualification:</span> M.A., B.Ed.</h5>
            </div>
            </div>
        </div>
        
            {/* <div className='teacherdata-box'>
                <div  className='teacherdata-inner-box'>
                <div className='teacher-img'>
                <img src='../newimg/Teacher Photo/Muskan shekhawat.webp'/>
                </div>
                <div className='teacher-data-box'>
                <h1>Muskan Shekhawat </h1>
                <h5><span>Designation:</span> PYP Facilitator </h5>  
                <h5><span>Qualification:</span>B.A., B.Ed.</h5>
                </div>
                </div>
            </div> */}
      
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Tanya yadav.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Tanya Yadav </h1>
            <h5><span>Designation:</span> PYP Facilitator </h5>  
            <h5><span>Qualification:</span>B.Sc., B.Ed </h5>
            </div>
            </div>
        </div>
       
       
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Shubhra gupta.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Shubhra Gupta</h1>
            <h5><span>Designation:</span>  Dance Teacher </h5>  
            <h5><span>Qualification:</span>B. Com.  </h5>
            </div>
            </div>
        </div>
       
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Bhawna taneja.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Bhawna Taneja</h1>
            <h5><span>Designation:</span> Dance Teacher</h5>  
            <h5><span>Qualification:</span>M.Com, B.Com.
            </h5>
            </div>
            </div>
        </div>
{/*         
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Pooja shrivastava.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Pooja Shrivastava</h1>
            <h5><span>Designation:</span>PYP Facilitator </h5>  
            <h5><span>Qualification:</span>B.A., B.Ed. </h5>
            </div>
            </div>
        </div> */}
{/*         
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Ishan warsi.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Ishan Warsi</h1>
            <h5><span>Designation:</span> </h5>  
            <h5><span>Qualification:</span> </h5>
            </div>
            </div>
        </div> */}
        
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Shilpi chaurasiya.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Shilpi Chaurasia</h1>
            <h5><span>Designation:</span>PYP Facilitator</h5>  
            <h5><span>Qualification:</span>M.A., B.Ed. </h5>
            </div>
            </div>
        </div>
       
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            {/* <img src='../newimg/Teacher Photo/Sapna sehgal.webp'/> */}
            <img src='../newimg/Teacher Photo/Swati gupta.webp'/>
            
            </div>
            <div className='teacher-data-box'>
            <h1>Sapna Shegal</h1>
            <h5><span>Designation:</span>IGCSE Facilitator</h5>  
            <h5><span>Qualification:</span>B.A., B.Ed</h5>
            </div>
            </div>
        </div>
       
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Neena pareek.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Neena Pareek</h1>
            <h5><span>Designation:</span> Music Teacher</h5>  
            <h5><span>Qualification:</span> M.A. (English)</h5>
            </div>
            </div>
        </div>
      
        {/* <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Nisha soni.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Nisha Soni</h1>
            <h5><span>Designation:</span>PYP Facilitator</h5>  
            <h5><span>Qualification:</span>M.A., B.Ed</h5>
            </div>
            </div>
        </div> */}
        
        {/* <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Rachna sharma.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Rachna Sharma</h1>
            <h5><span>Designation:</span>PYP Facilitator</h5>  
            <h5><span>Qualification:</span>M.Sc., B.Ed</h5>
            </div>
            </div>
        </div> */}

        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Meghna gehlot.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Meghna Gahlot</h1>
            <h5><span>Designation:</span>IGCSE Facilitator</h5>  
            <h5><span>Qualification:</span>M.A. </h5>
            </div>
            </div>
        </div>
    
      
        {/* <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Vishal Mertia </h1>
            <h5><span>Designation:</span>IGCSE Facilitator</h5>  
            <h5><span>Qualification:</span></h5>
            </div>
            </div>
        </div> */}
        
        {/* <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/roopali-bhargava.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Roopali Bhargava </h1>
            <h5><span>Designation:</span>IGCSE / DP / French Facilitator</h5>  
            <h5><span>Qualification:</span>B.Com., B.Ed.</h5>
            </div>
            </div>
        </div> */}
   
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Kumkum-Jain.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Kumkum Jain </h1>
            <h5><span>Designation:</span>IGCSE Facilitator </h5>  
            <h5><span>Qualification:</span>M.A., B.Ed. </h5>
            </div>
            </div>
        </div>
      
       
        {/* <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Surbhi Pareek</h1>
            <h5><span>Designation:</span>Librarian</h5>  
            <h5><span>Qualification:</span>M.Com, M. Lib.</h5>
            </div>
            </div>
        </div> */}
       
        {/* <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Madina Behlim.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Ms. Madina Behlim</h1>
            <h5><span>Designation:</span>PYP Facilitator</h5>  
            <h5><span>Qualification:</span>M.B.A., B.Com.</h5>
            </div>
            </div>
        </div> */}
       
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Deepa-singh.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Ms. Deepa Singh</h1>
            <h5><span>Designation:</span>PYP Facilitator</h5>  
            <h5><span>Qualification:</span>B.Sc., B.Ed. </h5>
            </div>
            </div>
        </div>
        
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Tanu joshi.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Tanu Joshi</h1>
            <h5><span>Designation:</span>PYP Facilitator</h5>  
            <h5><span>Qualification:</span>B.Sc., B.Ed.</h5>
            </div>
            </div>
        </div>
       
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Cheena Gulati.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Ms. Cheena Gulati</h1>
            <h5><span>Designation:</span>PYP Facilitator</h5>  
            <h5><span>Qualification:</span>M.A., B.Ed. </h5>
            </div>
            </div>
        </div>
       
        {/* <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Gunjan Rathore.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Ms. Gunjan Rathore </h1>
            <h5><span>Designation:</span>PYP Facilitator</h5>  
            <h5><span>Qualification:</span>M. Com., B.Ed. </h5>
            </div>
            </div>
        </div> */}
       
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Pinki Ranwa.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Pinky Ranwa</h1>
            <h5><span>Designation:</span>Sports</h5>  
            <h5><span>Qualification:</span>B.Com, B.P.Ed., M.P.Ed</h5>
            </div>
            </div>
        </div>
         {/* <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Isha kumawat.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Isha Kumawat</h1>
            <h5><span>Designation:</span>PYP Facilitator</h5>  
            <h5><span>Qualification:</span> B.Sc., M.Sc, B.Ed., M.A. </h5>
            </div>
            </div>
        </div> */}
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Sonal Purohit.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Sonal Purohit</h1>
            <h5><span>Designation:</span>PYP Facilitator</h5>  
            <h5><span>Qualification:</span> BCA, MCA</h5>
            </div>
            </div>
        </div>
       
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Neha shekhawat.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Neha Shekhawat</h1>
            <h5><span>Designation:</span>PYP Facilitator</h5>  
            <h5><span>Qualification:</span>B.Com., M.Com., B.Ed.</h5>
            </div>
            </div>
        </div>
    
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Arshi siddiqui.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Arshi Siddiqui</h1>
            <h5><span>Designation:</span>PYP Facilitator</h5>  
            <h5><span>Qualification:</span>B.Com., M.Com., DNIIT, M.Sc(II) </h5>
            </div>
            </div>
        </div>

        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Kanika masiwal.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Kanika Masiwal</h1>
            <h5><span>Designation:</span>French Facilitator</h5>  
            <h5><span>Qualification:</span>B.A.(Hons), M.A.(French) </h5>
            </div>
            </div>
        </div>

        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Monika gangwani.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Monika Gangwani</h1>
            <h5><span>Designation:</span>PYP Facilitator</h5>  
            <h5><span>Qualification:</span>B.Com., M.Com. </h5>
            </div>
            </div>
        </div>

        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Mitanksha sharma.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Mitanksha Sharma</h1>
            <h5><span>Designation:</span>PYP Facilitator</h5>  
            <h5><span>Qualification:</span>B.A., M.A., B.Ed.</h5>
            </div>
            </div>
        </div>

        {/* <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Alka ameria.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Alka Ameria</h1>
            <h5><span>Designation:</span>PYP Facilitator</h5>  
            <h5><span>Qualification:</span>B.A., NTT, Diploma in Marketing & Advertising </h5>
            </div>
            </div>
        </div> */}

        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Neha ugrawat.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Neha Ugrawat</h1>
            <h5><span>Designation:</span>PYP Facilitator</h5>  
            <h5><span>Qualification:</span>M.Com., B.Ed., M.B.A., Diploma in Computer </h5>
            </div>
            </div>
        </div>

        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Tripti Rathore.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Tripti Rathore</h1>
            <h5><span>Designation:</span>PYP Facilitator</h5>  
            <h5><span>Qualification:</span>B.A. (English Hons), M.A. (English Lit.)</h5>
            </div>
            </div>
        </div>

        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Radhika Rathore.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Radhika Rathore</h1>
            <h5><span>Designation:</span>PYP Facilitator</h5>  
            <h5><span>Qualification:</span>B.Com., M.Com. </h5>
            </div>
            </div>
        </div>

       

        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Divya Sharma.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Divya Sharma</h1>
            <h5><span>Designation:</span>PYP Facilitator</h5>  
            <h5><span>Qualification:</span> M.A., B.Ed. </h5>
            </div>
            </div>
        </div>

        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Deepanshi gehlot.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Deepanshi Gehlot</h1>
            <h5><span>Designation:</span>PYP Art Facilitator</h5>  
            <h5><span>Qualification:</span> B.V.A</h5>
            </div>
            </div>
        </div>

        {/* <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Anjali Rathore.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Anjali Rathore</h1>
            <h5><span>Designation:</span>PYP Art Facilitator</h5>  
            <h5><span>Qualification:</span> B.A., B.Ed.</h5>
            </div>
            </div>
        </div> */}    
        {/* <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Neha Kapila.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Neha Kapila</h1>
            <h5><span>Designation:</span>PYP Facilitator</h5>  
            <h5><span>Qualification:</span> M.Sc, B.Ed.</h5>
            </div>
            </div>
        </div> */}
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Sujata-Singh.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Sujata Singh</h1>
            <h5><span>Designation:</span>:IGCSE & IBDP Facilitator</h5>  
            <h5><span>Qualification:</span> M.Sc, B.Ed.</h5>
            </div>
            </div>
        </div>
        
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/JyotsanaRathore.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Jyotsna Rathore</h1>
            <h5><span>Designation:</span>PYP Facilitator</h5>  
            <h5><span>Qualification:</span> M.A., B.Ed., N.T.T, Clinical Psychology </h5>
            </div>
            </div>
        </div>
        
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Radhika shekhawat.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Radhika Shekhawat</h1>
            <h5><span>Designation:</span>PYP Facilitator</h5>  
            <h5><span>Qualification:</span> M.Sc., B.Ed.,</h5>
            </div>
            </div>
        </div>
        
        <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Aditi Shekhawat.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Aditi Shekhawat</h1>
            <h5><span>Designation:</span>PYP Facilitator</h5>  
            <h5><span>Qualification:</span> M.A.</h5>
            </div>
            </div>
        </div>
        
        {/* <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/Teacher Photo/Sunita Pareek.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1>Sunita Pareek</h1>
            <h5><span>Designation:</span>PYP Facilitator</h5>  
            <h5><span>Qualification:</span>B.A., B.Ed.</h5>
            </div>
            </div>
        </div> */}
       
     
        {/* <div className='teacherdata-box'>
            <div  className='teacherdata-inner-box'>
            <div className='teacher-img'>
            <img src='../newimg/No_Image_Available.webp'/>
            </div>
            <div className='teacher-data-box'>
            <h1> Ms. Kajal Goyal </h1>
            <h5><span>Designation:</span> PYP Facilitator</h5>
            <h5><span>Qualification:</span>B.A.</h5>
            </div>
            </div>
        </div> */}
      </div>
        </div>
    </div>
  )
}
export default ourstaff
